export const FORM_FIELD_KEYS = {
	DATE_RANGE: 'dateRange',
	TOURNAMENT_ID: 'tournamentID',
	GAME_NAME: 'gameName',
	USER_ID: 'userId',
	INVOICE_TYPE: 'invoiceType'
};
export type InvoiceFilters = {
	dateRangeFrom?: number;
	dateRangeTill?: number;
	tournamentID?: number;
	gameName?: string;
	userId?: string;
	invoiceType?: string;
};

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: InvoiceFilters) => void;
	onClose: () => void;
};

export const INVOICE_TYPE = {
	TAX_INVOICE: 'TAX_INVOICE',
	ACKNOWLEDGMENT_SLIP: 'ACKNOWLEDGMENT_SLIP',
	CREDIT_NOTE: 'CREDIT_NOTE',
	REFUND_RECEIPT: 'REFUND_RECEIPT',
	DEPOSIT_TAX_INVOICE: 'DEPOSIT_TAX_INVOICE'
};

export const INVOICE_TYPE_OPTIONS = {
	[INVOICE_TYPE.TAX_INVOICE]: 'TAX_INVOICE',
	[INVOICE_TYPE.ACKNOWLEDGMENT_SLIP]: 'ACKNOWLEDGMENT_SLIP',
	[INVOICE_TYPE.CREDIT_NOTE]: 'CREDIT_NOTE',
	[INVOICE_TYPE.REFUND_RECEIPT]: 'REFUND_RECEIPT',
	[INVOICE_TYPE.DEPOSIT_TAX_INVOICE]: 'DEPOSIT_TAX_INVOICE'
};

export const INVOICE_TYPE_LABLES = {
	[INVOICE_TYPE.TAX_INVOICE]: 'TAX INVOICE',
	[INVOICE_TYPE.ACKNOWLEDGMENT_SLIP]: 'ACKNOWLEDGMENT SLIP',
	[INVOICE_TYPE.CREDIT_NOTE]: 'CREDIT NOTE',
	[INVOICE_TYPE.REFUND_RECEIPT]: 'REFUND RECEIPT',
	[INVOICE_TYPE.DEPOSIT_TAX_INVOICE]: 'DEPOSIT INVOICE'
};

export const GAME_NAMES = {
	LUDO: 'LUDO',
	NINJA: 'NINJA',
	TURBO: 'TURBO',
	SNLT: 'SNLT',
	CARROM: 'CARROM',
	CC: 'CC',
	TC: 'TC',
	QUIZ: 'QUIZ',
	LUDONX: 'LUDONX',
	CT: 'CT',
	SUPERAPP: 'SUPERAPP',
	TCNX: 'TCNX	'
};

export const GAME_NAME_OPTIONS = {
	[GAME_NAMES.LUDO]: 'ludo',
	[GAME_NAMES.NINJA]: 'ninja',
	[GAME_NAMES.TURBO]: 'turbo',
	[GAME_NAMES.SNLT]: 'snl',
	[GAME_NAMES.CARROM]: 'carrom',
	[GAME_NAMES.CC]: 'cc',
	[GAME_NAMES.TC]: 'tc',
	[GAME_NAMES.QUIZ]: 'quiz',
	[GAME_NAMES.CT]: 'ct',
	[GAME_NAMES.LUDONX]: 'ludonx',
	[GAME_NAMES.TCNX]: 'tcnx',
	[GAME_NAMES.SUPERAPP]: 'superapp'
};

export const GAME_NAME_LABLES = {
	[GAME_NAMES.LUDO]: 'Ludo Supreme',
	[GAME_NAMES.NINJA]: 'Ludo Ninja',
	[GAME_NAMES.TURBO]: 'Ludo Turbo',
	[GAME_NAMES.SNLT]: 'Snake and Ladders Plus',
	[GAME_NAMES.CARROM]: 'Carrom Ninja',
	[GAME_NAMES.CC]: 'Choco Crush',
	[GAME_NAMES.TC]: 'Trump Card',
	[GAME_NAMES.QUIZ]: 'Zupee Quiz',
	[GAME_NAMES.CT]: 'Cricket Tambola',
	[GAME_NAMES.LUDONX]: 'Ludo Supreme League',
	[GAME_NAMES.TCNX]: 'Trump Card League',
	[GAME_NAMES.SUPERAPP]: 'Superapp'
};

export const GAME_NAME = 'gameName';

export const PAGE_NO = 'pageNo';

export const INVOICE_TYPE_CONST = 'invoiceType';
